<section class="registration-page">
  <div class="registration-form-container">
    <h2>Regisztráció</h2>

    <p class="text-center small">
      Pusztán a regisztrációval SEMMILYEN plusz tartalomhoz vagy funkcióhoz nem férsz hozzá.
      Azaz ha nem azért szeretnél regisztrálni, mert részese vagy gyülekezetünk valamely szolgálatának,
      ami használja ezt a honlapot, akkor teljesen felesleges regisztrálnod.
      <br />
      Ha ennek ellenére szeretnél, semmi akadálya. =)
    </p>

    <ngb-alert *ngFor="let m of msgs" [type]="m.severity" (close)="closeAlert(m)">
      <strong>{{m.summary}}</strong> {{m.details}}
    </ngb-alert>

    <form (submit)="doRegistration(regForm)" #regForm="ngForm">
      <div class="form-group row">
        <label for="email" class="col-lg-3 col-form-label">Email:</label>
        <div class="col-lg-9">
          <input type="email"
                 id="email"
                 name="email"
                 [class.missing]="submitted && !user.email"
                 placeholder="Email"
                 [(ngModel)]="user.email"
                 class="form-control"
                 #emailField
                 required
          />
        </div>
      </div>
      <div class="form-group row">
        <label for="lastname" class="col-lg-3 col-form-label">Vezetéknév:</label>
        <div class="col-lg-9">
          <input type="text"
                 id="lastname"
                 name="lastname"
                 [class.missing]="submitted && !user.lastname"
                 placeholder="Vezetéknév"
                 [(ngModel)]="user.lastname"
                 class="form-control"
                 #lastNameField
                 required
          />
        </div>
      </div>
      <div class="form-group row">
        <label for="firstname" class="col-lg-3 col-form-label">Keresztnév:</label>
        <div class="col-lg-9">
          <input type="text"
                 id="firstname"
                 name="firstname"
                 [class.missing]="submitted && !user.firstname"
                 placeholder="Keresztnév"
                 [(ngModel)]="user.firstname"
                 class="form-control"
                 #firstNameField
                 required
          />
        </div>
      </div>
      <div class="form-group row">
        <label for="nickname" class="col-lg-3 col-form-label">Becenév:</label>
        <div class="col-lg-9">
          <input type="text"
                 id="nickname"
                 name="nickname"
                 placeholder="Becenév"
                 [(ngModel)]="user.nickname"
                 class="form-control"
                 #nickNameField
          />
        </div>
      </div>
      <div class="form-group row">
        <label for="password" class="col-lg-3 col-form-label">Jelszó:</label>
        <div class="col-lg-9">
          <input type="password"
                 id="password"
                 name="password"
                 [class.missing]="submitted && !user.password"
                 placeholder="Jelszó"
                 [(ngModel)]="user.password"
                 class="form-control"
                 #passwordField
                 required
          />
        </div>
      </div>
      <div class="form-group row">
        <label for="password_confirmation" class="col-lg-3 col-form-label">Jelszó újra:</label>
        <div class="col-lg-9">
          <input type="password"
                 id="password_confirmation"
                 name="password_confirmation"
                 [class.missing]="submitted && !user.password_confirmation"
                 placeholder="Jelszó újra"
                 [(ngModel)]="user.password_confirmation"
                 class="form-control"
                 #passwordConfirmationField
                 required
          />
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3"></div>
        <div class="col-lg-9 submit">
          <button type="submit"
                  [disabled]="pending"
                  class="btn btn-success"
          ><i class="fa fa-sign-in"></i> Regisztráció</button>
        </div>
      </div>
    </form>
  </div>
</section>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/auth/registration/registration.component.html